<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <validation-provider
          :name="$t('commands.selectable.name')"
          rules="required"
          v-slot="{ errors }"
        >
          <label class="d-block">
            {{ $t('commands.selectable.name') }}
          </label>
          <textarea
            class="form-control"
            v-model="fieldData.name"
            rows="2"
          />
          <p v-if="errors" class="small text-danger">
            {{ errors[0] }}
          </p>
        </validation-provider>
        <div class="mb-1">
          <label class="d-block">
            {{ $t('commands.selectable.addOptions') }}
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="option"
            >
            <div class="input-group-append">
              <button
                type="submit"
                class="btn btn-primary d-flex align-items-center justify-content-center"
              >
                <feather-icon icon="PlusIcon" size="15"/>
              </button>
            </div>
          </div>
        </div>
      </b-form>
    </validation-observer>
    <label>
      {{ $t('commands.selectable.options') }}
    </label>
    <b-alert
      v-if="!fieldData.options.length"
      show
      variant="warning"
      class="p-1"
    >
      {{ $t('commands.selectable.no_options') }}
    </b-alert>
    <b-list-group v-else>
      <b-list-group-item
        v-for="(option,index) in fieldData.options"
        :key="index"
        class="d-flex justify-content-between align-items-center"
      >
        {{ option }}
        <b-button
          variant="danger"
          size="sm"
          @click="deleteOption(index)"
        >
          <feather-icon icon="Trash2Icon"/>
        </b-button>
      </b-list-group-item>
    </b-list-group>
    <div class="rules mt-1">
      <template v-if="fieldData.type === 'Checkbox'">
        <label class="d-block" for="rules">
          Número de opciones seleccionadas requerido
        </label>
        <b-input
          id="rules"
          type="number"
          min="0"
          :max="optionsLength"
          size="sm"
          class="w-25"
          v-model="minSelected"
        />
      </template>
      <template v-else>
        <b-form-group
          label="Requerido"
          label-for="groups"
        >
          <b-form-checkbox
            v-model="ruleRequired"
            name="chek-dispatch-alarm"
            switch
          >
          </b-form-checkbox>
        </b-form-group>
      </template>
    </div>
    <p v-if="errorOptions" class="small text-danger mb-0">
      {{ $t('commands.selectable.optionsRequired') }}
    </p>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper'
import {BFormCheckbox, BFormGroup} from "bootstrap-vue";

export default {
  props: {
    fieldData: {
      type: Object
    },
    showPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BFormCheckbox, BFormGroup,
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  data() {
    return {
      errorOptions: false,
      option: null,
      withPopper: popperHelper.withPopper,
      chkBoxRules: 'required|length',
      minSelected: 0,
      ruleRequired: false,
    }
  },
  mounted() {
    if (this.fieldData.rules) {
      if (this.fieldData.type === 'Checkbox' && this.fieldData.rules.includes(`${this.chkBoxRules}:`)) {
        const chunks = this.fieldData.rules.split(`${this.chkBoxRules}:`) || [];
        this.minSelected = chunks[1] || 0;
      } else if (this.fieldData.type === 'Select') {
        this.ruleRequired = this.fieldData.rules === 'required';
      }
    }
  },
  computed: {
    rules: {
      get() {
        if (this.fieldData.type === 'Checkbox') {
          if (parseInt(this.minSelected) === 0) {
            return '';
          }
          return `${this.chkBoxRules}:${this.minSelected}`
        } else if (this.fieldData.type === 'Select') {
          if (!this.ruleRequired) {
            return '';
          }
          return 'required';
        }
      },
      set(value) {
        if (this.fieldData.type === 'Checkbox') {
          this.minSelected = value;
        } else {
          this.ruleRequired = value;
        }
      }
    },
    optionsLength() {
      return this.fieldData.options.length || 0;
    }
  },
  watch: {
    rules(val) {
      this.$set(this.fieldData, 'rules', val);
    }
  },
  methods: {
    deleteOption(indexOption) {
      this.fieldData.options.splice(indexOption, 1);
    },
    onSubmit() {
      if (this.option) {
        this.fieldData.options.push(this.option);
        this.$refs.refFormObserver.reset();

        this.option = null;
      }
    },
    setErrorOptions(value) {
      this.errorOptions = value;
    }
  }
}
</script>
